module.exports = __webpack_public_path__ + "static/media/homework.f5e2972f.svg";